import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { mockData } from '../mockData';

const values = [
  "Rigor técnico e responsabilidade",
  "Abordagem prática do Direito",
  "Atuação transparente e objetiva",
  "Acompanhamento individualizado",
  "Soluções concretas e sustentadas"
];

const AboutImage = () => (
  <div className="relative order-2 lg:order-1">
    <div className="relative rounded-lg overflow-hidden shadow-2xl">
      <img
        src={mockData.images.about}
        alt="Sobre Barros & Durães Advogados"
        className="w-full h-[600px] object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-navy/40 to-transparent"></div>
    </div>
    <div className="absolute -bottom-8 -right-8 bg-gold p-8 rounded-lg shadow-xl max-w-xs hidden md:block">
      <div className="text-white">
        <div className="text-4xl font-bold font-serif mb-2">Excelência</div>
        <div className="text-white/90">em serviços jurídicos desde a nossa fundação</div>
      </div>
    </div>
    <div className="absolute -top-4 -left-4 w-20 h-20 border-4 border-gold rounded-full"></div>
  </div>
);

const AboutValues = () => (
  <div className="space-y-4 pt-6">
    <h3 className="font-semibold text-xl text-navy mb-4">Os Nossos Valores:</h3>
    {values.map((value) => (
      <div key={value} className="flex items-start space-x-3">
        <CheckCircle2 className="w-6 h-6 text-gold flex-shrink-0 mt-0.5" />
        <span className="text-navy/80 text-lg">{value}</span>
      </div>
    ))}
  </div>
);

const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <AboutImage />

          <div className="space-y-8 order-1 lg:order-2">
            <div className="space-y-4">
              <div className="inline-block">
                <span className="text-gold font-semibold text-sm uppercase tracking-wider">
                  {mockData.aboutUs.title}
                </span>
              </div>
              <h2 className="font-serif text-4xl md:text-5xl font-bold text-navy leading-tight">
                Compromisso com a
                <span className="text-gold"> Excelência Jurídica</span>
              </h2>
            </div>

            <div className="space-y-6">
              {mockData.aboutUs.content.slice(0, 3).map((paragraph) => (
                <p key={paragraph} className="text-navy/70 text-lg leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>

            <AboutValues />

            <div className="border-l-4 border-gold pl-6 py-4 bg-cream/30 rounded-r-lg">
              <p className="text-navy/80 italic text-lg leading-relaxed">
                "Cada processo é acompanhado de forma individualizada, com proximidade, organização e sentido de compromisso."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
